import { PageHero, CtaBlock, TextLink, BrowserFrame } from "@/components/site/Ui";
import { Clip, Reveal } from "@/components/site/Motion";
import { Bullets } from "@/components/site/Split";
import { sectors, projects } from "@/content/site";
import { useSeo } from "@/lib/seo";

export default function Secteurs() {
  useSeo({
    title: "Secteurs — sites pour restaurants, instituts, commerces, artisans",
    description: "Création de site pour restaurant, institut de beauté, commerce indépendant ou artisan à Toulouse : ce qui compte pour chaque secteur.",
    path: "/secteurs",
  });
  return (
    <>
      <PageHero testid="secteurs-hero" label="Secteurs" lines={["Pensé pour les commerces", "de proximité."]}
        intro="Un client de restaurant cherche la carte et les horaires. Une cliente d'institut veut voir les soins et réserver. Je pars de ces usages." />
      {sectors.map((s, i) => {
        const p = projects.find((x) => x.slug === s.project);
        return (
          <section key={s.id} id={s.id} className="wrap grid items-center gap-10 border-t border-ink/20 py-14 md:py-20 lg:grid-cols-12" data-testid={`sector-${s.id}`}>
            <Reveal className={p ? "lg:col-span-5" : "lg:col-span-6"}>
              <p className="label mb-4">0{i + 1} — {s.who}</p>
              <h2 className="display h-lg">{s.title}</h2>
              <p className="mt-5 text-[17px] leading-relaxed text-mute">{s.pitch}</p>
              {p && <TextLink to={`/realisations/${p.slug}`} className="mt-6" testid={`sector-project-${s.id}`}>Exemple : {p.name}</TextLink>}
            </Reveal>
            <div className={p ? "lg:col-span-7" : "lg:col-span-5 lg:col-start-8"}>
              {p ? (
                <Clip><BrowserFrame src={p.shots.home} alt={`Page d'accueil du site ${p.name}`} label={p.domain || p.name} /></Clip>
              ) : (
                <Reveal><Bullets items={s.stakes} /><TextLink to="/diagnostic" className="mt-6" testid={`sector-cta-${s.id}`}>Échanger sur mon activité</TextLink></Reveal>
              )}
            </div>
          </section>
        );
      })}
      <CtaBlock />
    </>
  );
}
